<template>
  <div ref="container">
    <div class="coupon-list" v-if="couponsList.length > 0">
      <div
        class="item acea-row row-center-wrapper"
        v-cloak
        v-for="(item, index) in couponsList"
        :key="index"
      >
        <div class="money" :class="item.status > 0 ? 'moneyGray' : ''">
          <div>
            ￥<span class="num">{{ item.usedAmount }}</span>
          </div>
          <div class="desc">
            {{ item.type === 0 ? "无门槛券" : `满${item.withAmount}元可用` }}
          </div>
        </div>

        <div class="text">
          <div class="condition line1">{{ item.title }}</div>
          <div class="use-type" v-if="item.useType === 10">全场券</div>
          <div class="use-type" v-if="item.useType === 20">项目优惠券</div>
          <div class="use-type" v-if="item.useType === 30">类目优惠券</div>
          <div class="data acea-row row-between-wrapper">
            有效期至：{{ fromatDate(item.endTime) }}
            <div class="bnt gray" v-if="item.status === 1">已使用</div>
            <div class="bnt gray" v-if="item.status === 2">已过期</div>
          </div>
        </div>
      </div>
    </div>
    <!--暂无优惠券-->
    <div
      class="noCommodity"
      v-if="couponsList.length === 0 && loading === true"
    >
      <div class="noPictrue">
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>
  </div>
</template>
<script>
import { getCouponsUser } from "@api/user";
import dayjs from "dayjs";

const NAME = "UserCoupon";

export default {
  name: "UserCoupon",
  components: {},
  props: {},
  data: function () {
    return {
      couponsList: [],
      loading: false,
    };
  },
  watch: {
    $route: function (n) {
      var that = this;
      if (n.name === NAME) {
        that.getUseCoupons();
      }
    },
  },
  mounted: function () {
    this.getUseCoupons();
  },
  methods: {
    fromatDate(time) {
      return dayjs(time).format("YYYY-MM-DD");
    },
    getUseCoupons: function () {
      getCouponsUser().then((res) => {
        this.couponsList = res.result;
        this.loading = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon-list .item {
  .money {
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .desc {
      color: #ffffff;
      font-size: 12px;
      text-align: center;
      font-weight: 400;
      margin-top: 5px;
    }
  }
  .text {
    height: 1.7rem;
    .condition {
      padding: 12px 0 10px;
      line-height: 1;
      height: initial;
      border-bottom: none;
    }
    .use-type {
      font-size: 12px;
      margin-bottom: 5px;
    }
    .data {
      font-size: 12px;
      height: initial;
    }
  }
}
</style>
